import {z} from 'zod';
import {tradeTagDbSchema} from './tradeTagDbSchema';

export const tradeTagSchema = tradeTagDbSchema.extend({
  id: z.string(),
});

export interface TradeTag extends z.infer<typeof tradeTagSchema> {}
